"use client";

import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiIncomingIdentitySubscriptionsPage } from "@/generated/models/ApiIncomingIdentitySubscriptionsPage";
import type { ApiIdentityAndSubscriptionActions } from "@/generated/models/ApiIdentityAndSubscriptionActions";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
const REQUEST_SIZE = 100;
export function useWaveFollowers(waveId) {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      page_size: `${REQUEST_SIZE}`
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = t0;
  let t1;
  if ($[1] !== waveId) {
    t1 = {
      queryKey: [QueryKey.WAVE_FOLLOWERS, {
        ...query,
        target_type: "WAVE",
        wave_id: waveId
      }],
      queryFn: async t2 => {
        const {
          pageParam
        } = t2;
        const params = {
          ...query
        };
        if (pageParam) {
          params.page = `${pageParam}`;
        }
        return await commonApiFetch({
          endpoint: `/identity-subscriptions/incoming/WAVE/${waveId}`,
          params
        });
      },
      initialPageParam: null,
      getNextPageParam: _temp
    };
    $[1] = waveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status
  } = useInfiniteQuery(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [followers, setFollowers] = useState(t2);
  let t3;
  if ($[4] !== data?.pages) {
    t3 = () => setFollowers(data?.pages.flatMap(_temp2) ?? []);
    $[4] = data?.pages;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== data) {
    t4 = [data];
    $[6] = data;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== fetchNextPage || $[9] !== followers || $[10] !== hasNextPage || $[11] !== isFetching || $[12] !== isFetchingNextPage || $[13] !== status) {
    t5 = state => {
      if (followers.length < REQUEST_SIZE) {
        return;
      }
      if (!state || status === "pending" || isFetching || isFetchingNextPage || !hasNextPage) {
        return;
      }
      fetchNextPage();
    };
    $[8] = fetchNextPage;
    $[9] = followers;
    $[10] = hasNextPage;
    $[11] = isFetching;
    $[12] = isFetchingNextPage;
    $[13] = status;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const onBottomIntersection = t5;
  let t6;
  if ($[15] !== followers || $[16] !== isFetching || $[17] !== onBottomIntersection) {
    t6 = {
      followers,
      isFetching,
      onBottomIntersection
    };
    $[15] = followers;
    $[16] = isFetching;
    $[17] = onBottomIntersection;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
function _temp2(page) {
  return page.data;
}
function _temp(lastPage) {
  return lastPage.next ? lastPage.page + 1 : null;
}